module.exports = __webpack_public_path__ + "66c51250d95dcadd73c8097df91bdc27.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/bigMap.png
// module id = 1100
// module chunks = 0